module.exports = {
  WECHAT_CACHEKEY_COOKIE: '_wck',
  WECHAT_NICKNAME_PARAM: '_wcnn',
  WECHAT_GENDER_PARAM: '_wcg',
  WECHAT_ERROR_ID: 'wechat_error',
  WECHAT_IDM_PROVIDER: 'wechat',
}
